import { List } from 'immutable';
import { PaymentStatus } from '../models/payment-status.enum';

export class PaymentStatusUtils {

  static readonly ERROR_CODES = List<PaymentStatus>([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR
  ]);

  static isError(paymentStatus: PaymentStatus): boolean {
    return this.ERROR_CODES.contains(paymentStatus);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/payment-status-utils.ts